export const fontWeights = [
    400,
    600,
    700,
];
//# sourceMappingURL=fontWeights.js.map